





















import { Component, Prop, Vue } from "vue-property-decorator";
import { DebugHelper } from "@/helper/debugHelper";

@Component({
  components: {
  }
})

export default class RegetModal extends Vue {
    @Prop() private title! : string;
    @Prop() private message! : string;

    private cancel(){
        this.$router.push("/SelectTemplate");
    }

    private reacquire(){
        this.$emit("doCommand", "reacquire");
    }
    
    private get userConfigButtonColorStyle(){
        var style = {
            backgroundColor : this.$store.getters.userConfigColors.buttonColorCode
        };
        return style;
    }
}
